import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import Auth from './utils/Auth';
import Authenticate from './components/Authenticate';
import history from './utils/history';
import AuthenicatedRoute from './components/AuthenicatedRoute';

const auth = new Auth();

const App = () => (
	<Router history={history}>
		<Switch>
			<Route
				exact
				path="/authenticate"
				render={props => <Authenticate auth={auth} {...props} />}
			/>
			<Route render={props => <AuthenicatedRoute auth={auth} {...props} />} />
		</Switch>
	</Router>
);

export default App;
